import React from "react";
import Hero from "../component/outright-ride/hero";
import WhatsappSlideout from "../component/outright-ride/WhatsappSlideout";
import { Layout } from "../component/Layout";
import useGlobalStore from "../store/global";

function OutrightRide() {
  const { isSignupOpen, toggleIsSignupOpen } = useGlobalStore((state) => ({
    isSignupOpen: state.data.isSignupOpen,
    toggleIsSignupOpen: state.toggleIsSignupOpen,
  }));

  return (
    <Layout>
      <div className="wrapper">
        <div className="main">
          <Hero />
        </div>
        <WhatsappSlideout
          isActive={isSignupOpen}
          handleToggle={() => toggleIsSignupOpen()}
        />
      </div>
    </Layout>
  );
}

export default OutrightRide;
